import { useAutoAnimate } from "@formkit/auto-animate/react";
import React, { useState } from "react";

export function SlideDown({ title, content, ...props }) {
  const [show, setShow] = useState(false);
  const toggleShow = () => setShow((prevState) => !prevState);
  const [parent] = useAutoAnimate(/* optional config */);

  return (
    <div className="NewsListItem--content" ref={parent}>
      <div
        className="NewsListItem--link py-3 !pl-0 text-[1.125rem] text-[#0028A5] hover:cursor-pointer"
        onClick={toggleShow}
      >
        {title}
      </div>
      {show && <div className="richtext pb-3">{content}</div>}
    </div>
  );
}
